import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css'
import '../scss/app.scss';

import Router from './Router';

class App extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      loaded: false
    }
  }

  componentDidMount() {
    window.addEventListener('load', () => {
      this.setState({ loading: false });
      setTimeout(() => this.setState({ loaded: true }), 500);
    });
  }

  render() {
    const loaded = this.state.loaded;
    return (
      <div>
        {!loaded && 
        <div className={`load${(this.state || {}).loading ? '' : ' loaded'}`}>
          <div className='load__icon-wrap'>
            {/* <svg className='load__icon'>
              <path fill='#03b0b0' d='M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z' />
            </svg> */}

              <div id="preloader">
                    <div id="loader">
                        <div className="loader-mid"></div>
                        <img className="loder-logo" src={(require('../img/logo.png'))} alt='catalog-item-img' />
                    </div>
                   
                    <div className="loader-section loader-top"></div>
                    <div className="loader-section loader-bottom"></div>
                   
                </div>
          </div>
        </div>
         }
        <div>
          <Router />
        </div>
      </div>
    )
  }
}

// const mapStateToProps = (state) => ({
//   user: state.User,
// });

// const mapDispatchToProps = (dispatch) =>(
//   bindActionCreators({}, dispatch)
// )

// export default compose(
//   connect(
//     mapStateToProps,
//     mapDispatchToProps
//     )
// )(App);

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js